var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path19, _rect10, _rect11, _rect12, _rect13, _rect14, _path20, _circle, _circle2, _circle3, _path21, _circle4, _circle5, _circle6, _path22, _rect15, _rect16, _path23, _circle7, _circle8, _circle9, _path24, _rect17, _path25, _g, _path26, _path27, _path28, _path29, _path30, _path31, _rect18, _rect19, _rect20, _rect21, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDockviewGrid4 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 200,
    fill: "none",
    viewBox: "0 0 312 200",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 311.504,
    height: 200,
    fill: "#fff",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M0 5a5 5 0 0 1 5-5h302a5 5 0 0 1 5 5v6H0V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M0 10h312v1H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M0 11h156v189H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M188 11h124v91H188zM188 102h124v98H188zM0 24h187v176H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M188 102h124v1H188zM188 11h-1v189h1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M0 11h187v14H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M0 11h35.962v14H0zM37.16 11h35.962v14H37.16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M74.32 11h35.962v14H74.32z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M35.962 11h1.199v14h-1.199zM73.122 11h1.199v14h-1.199zM110.282 11h1.199v14h-1.199z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M188 11h124v14H188z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M188 11h30v14h-30z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M219 11h30v14h-30z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M218 11h1v14h-1zM249 11h1v14h-1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M188 103h124v14H188z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M188 103h24v14h-24z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M212 103h24v14h-24z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M212 103h.503v14H212zM236 103h.503v14H236z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76 18a2 2 0 0 1 2-2h3a2 2 0 1 1 0 4h-3a2 2 0 0 1-2-2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 85,
    y: 16,
    fill: "#fff",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 222,
    y: 16,
    fill: "#777",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    x: 214,
    y: 108,
    fill: "#777",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 4,
    x: 222,
    y: 108,
    fill: "#777",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 237,
    y: 16,
    fill: "#777",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    x: 191,
    y: 16,
    fill: "#282828",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 197,
    y: 16,
    fill: "#282828",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 191,
    y: 108,
    fill: "#282828",
    rx: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M39 18a2 2 0 0 1 2-2h11a2 2 0 1 1 0 4H41a2 2 0 0 1-2-2Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 4,
    y: 3,
    fill: "#FD605E",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 3,
    fill: "#FBBC3F",
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 3,
    fill: "#34C942",
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 2,
    y: 16,
    fill: "#777",
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 10,
    y: 16,
    fill: "#777",
    rx: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M173 11h14v14h-14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 176 18)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 184 18)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 180 18)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M298 11h14v14h-14z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 301 18)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 309 18)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 18,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 305 18)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M111 11h14v14h-14z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.333,
    height: 8,
    x: 117.333,
    y: 14,
    fill: "#fff",
    rx: 0.667
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 1.333,
    height: 8,
    x: 114,
    y: 18.666,
    fill: "#fff",
    rx: 0.667,
    transform: "rotate(-90 114 18.666)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M298 103h14v14h-14z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 301,
    cy: 110,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 301 110)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 309,
    cy: 110,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 309 110)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 110,
    r: 1,
    fill: "#fff",
    transform: "rotate(-90 305 110)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M285 103h14v14h-14z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 288.5,
    y: 106.5,
    stroke: "#fff",
    rx: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M288 109h8v2h-8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M40 45h128.769v91H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M40 136h128.769v1H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M40 45h128.769v14H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M40 45h31.154v14H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M72.192 45h31.154v14H72.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M71.154 45h1.038v14h-1.038zM40 45h1v92h-1zM168 45h1v92h-1zM103.346 45h1.038v14h-1.038z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.461,
    height: 4,
    x: 75.308,
    y: 50,
    fill: "#777",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.154,
    height: 4,
    x: 90.885,
    y: 50,
    fill: "#777",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.192,
    height: 4,
    x: 43.115,
    y: 50,
    fill: "#282828",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.615,
    height: 4,
    x: 49.346,
    y: 50,
    fill: "#282828",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M40 45h128.769v1H40z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M29 54h128.769v91H29z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M29 145h128.769v1H29z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C2A",
    d: "M29 54h128.769v14H29z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#10192C",
    d: "M29 54h31.154v14H29z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000C18",
    d: "M61.192 54h31.154v14H61.192z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M60.154 54h1.038v14h-1.038zM29 54h1v92h-1zM157 54h1v92h-1zM92.346 54h1.038v14h-1.038z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 12.461,
    height: 4,
    x: 64.308,
    y: 59,
    fill: "#777",
    rx: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4.154,
    height: 4,
    x: 79.885,
    y: 59,
    fill: "#777",
    rx: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 5.192,
    height: 4,
    x: 32.115,
    y: 59,
    fill: "#282828",
    rx: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 16.615,
    height: 4,
    x: 38.346,
    y: 59,
    fill: "#282828",
    rx: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B4A",
    d: "M29 54h128.769v1H29z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M128.344 61.265a.295.295 0 0 0-.017-.495l-4.147-2.48a.295.295 0 0 0-.441.31l.912 4.744c.04.21.284.309.459.186l.662-.463a.296.296 0 0 0 .12-.298l-.29-1.508a.296.296 0 0 1 .442-.309l1.318.788c.1.06.226.055.321-.011l.661-.464Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeDasharray: ".25 .25",
    d: "M127.5 62.5h4v2h-4z"
  })));
};
export default SvgDockviewGrid4;